export default __webpack_public_path__ + "static/media/8.922c1952.jpg";